import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=9f70b614&"
import script from "./LoadingButton.vue?vue&type=script&lang=ts&"
export * from "./LoadingButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports